import { render, staticRenderFns } from "./login.page.vue?vue&type=template&id=44c699fa&scoped=true&"
import script from "./login.page.vue?vue&type=script&lang=js&"
export * from "./login.page.vue?vue&type=script&lang=js&"
import style0 from "./login.page.vue?vue&type=style&index=0&id=44c699fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c699fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VLayout})
